export var MessageType;
(function(MessageType) {
    MessageType["CALL"] = "CALL";
    MessageType["CALL_ERROR"] = "CALL_ERROR";
    MessageType["CALL_RESPONSE"] = "CALL_RESPONSE";
    MessageType["ADD_SUBSCRIPTION"] = "ADD_SUBSCRIPTION";
    MessageType["REMOVE_SUBSCRIPTION"] = "REMOVE_SUBSCRIPTION";
    MessageType["SUBSCRIPTION_RESULT"] = "SUBSCRIPTION_RESULT";
})(MessageType || (MessageType = {}));

//# sourceMappingURL=types.js.map